import { ChevronLeft } from "baseui/icon";
import React from "react";
import { useNavigate } from "react-router-dom";

import { SettingsIconButton } from "../../../../components/button/SettingsIconButton";
import { InvoicesStatuses } from "../components/InvoicesStatuses";
import { PaymentsStatuses } from "../components/PaymentsStatuses";

export const BillingLabels = () => {
  const navigate = useNavigate();

  return (
    <div className={"font-Manrope"}>
      <div className={"my-6 flex items-center gap-2"}>
        <SettingsIconButton
          hasShadow={false}
          icon={<ChevronLeft />}
          onClick={() => navigate(-1)}
        />
        <div className={"text-2xl font-semibold"}>Billing Settings</div>
      </div>

      <div className={"grid w-full max-w-[1020px] grid-cols-2 gap-4"}>
        <InvoicesStatuses />
        <PaymentsStatuses />
      </div>
    </div>
  );
};
